import algoliasearch, { SearchClient } from 'algoliasearch'

export const createSearchClient = (apiKey: string): SearchClient =>
	algoliasearch(process.env.NEXT_PUBLIC_ALGOLIA_APP_ID, apiKey)
